import { render, staticRenderFns } from "./InvioPrenotazioni.vue?vue&type=template&id=ed6ef394&"
import script from "./InvioPrenotazioni.vue?vue&type=script&lang=js&"
export * from "./InvioPrenotazioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports